// @flow
import React from "react";
import styles from "./Checkbox.scss";

type Props = {
  name: string,
  indeterminate: boolean
};

const Checkbox = (props: Props) => {
  const { name, indeterminate, variant,  ...rest } = props;
  return (
    <div className={`${styles.ctr} ${variant ? styles[variant] : ''}`}>
      <input
        type="checkbox"
        ref={input => {
          if (input) {
            input.indeterminate = indeterminate;
          }
        }}
        id={name}
        {...rest}
      />
      <label htmlFor={name} />
    </div>
  );
};

export default Checkbox;



// WEBPACK FOOTER //
// ./src/components/common/checkbox/Checkbox.js